export class City {
    public id: number;
    public code: string;
    public name: string;
    public departmentId: number;
    public categoryDay: number;
    public categoryId: number;
    public active: boolean;
    public activeCm: boolean;
    public category: string;
    public department: string;

    constructor() { }
}